import utils from '@/utils'
/**
 * 对象转数组
 * @param {*} obj 
 * @returns 
 */
export const objToList = (obj = {}) => {
    const keys = Object.keys(obj)
    if (keys.length <= 0) return

    return keys.reduce((list, item) => {
        return list.concat([obj[item]])
    }, [])
}

/**
 * 检测长度
 * @param {*} strTemp 
 * @returns 
 */
export const checkLength = strTemp => {
    let length = 0

    if (strTemp) {
        const strGbk = utils.gbk.encode(strTemp)

        length = strGbk.length
    }

    return length
}